export const enum NudgeType {
  CONGRATS = 'congrats',
  GUIDANCE = 'guidance',
  REMINDER = 'reminder',
}
